import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import MergeUsersForm from './components/merge-users-form';
import ManageEmailsDialog from './components/manage-emails/manage-emails-dialog';

export default function Users() {
  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>Users</CardTitle>
          <CardDescription>Manage your application users.</CardDescription>
        </CardHeader>

        <div className="flex flex-wrap">
          <MergeUsersForm />
          <ManageEmailsDialog />
        </div>
      </Card>
    </>
  );
}
